import { DwModalService } from 'ng-quicksilver';
import { LoginComponent } from './login/login.component';
import * as i0 from "@angular/core";
import * as i1 from "ng-quicksilver";
var FxLoingingService = /** @class */ (function () {
    function FxLoingingService(dwModalService) {
        this.dwModalService = dwModalService;
    }
    FxLoingingService.prototype.openLoginModal = function (fxMedia) {
        this.dwModalService.create({
            dwTitle: null,
            dwStyle: fxMedia == 'mobile' ? { margin: '0 5%', top: '150px' } : { top: '100px' },
            // dwBodyStyle: {background: '#ccc'},
            dwWrapClassName: (fxMedia && fxMedia === 'mobile') ? 'fx-login-wrap fx_lg_modal' : 'fx-login-wrap',
            dwMaskClosable: false,
            dwContent: LoginComponent,
            dwWidth: (fxMedia && fxMedia === 'mobile') ? window.screen.width * 0.4 : window.screen.width * 0.5,
            dwFooter: null,
            dwComponentParams: {
                modalScope: this
            },
        });
    };
    FxLoingingService.ngInjectableDef = i0.defineInjectable({ factory: function FxLoingingService_Factory() { return new FxLoingingService(i0.inject(i1.DwModalService)); }, token: FxLoingingService, providedIn: "root" });
    return FxLoingingService;
}());
export { FxLoingingService };
